<template>
  <div id="goTop">
    <Header :url="url"></Header>
    <van-swipe :autoplay="3000" style="margin-top:1rem">
      <van-swipe-item
        v-for="(image, index) in images"
        @click="tolink(image)"
        :key="index"
      >
        <img class="banner" :src="image.posterImg" alt />
      </van-swipe-item>
    </van-swipe>
    <p class="top-title">全球商标就找麦德通</p>
    <div class="index">
      <div class="bg-white bg-white-padding">
        <img style="width:100%" src="/static/img/index/index1.png?v=0" alt />
      </div>
      <!-- 活动模块 -->
      <activityConfiguration ref="activityConfiguration" />
      <div class="bg-white">
        <p class="server-title">全球商标服务</p>
        <p class="sub-title" style="">服务费(含官费)</p>
        <div :class="['server-title-div']">
          <div
            :class="[
              'title-item',
              feeSelect == i.value ? 'title-item-select' : ''
            ]"
            v-for="(i, k) in categoryList"
            :key="k"
            @click="serverChange(i)"
          >
            {{ i.label }}
          </div>
        </div>
        <div class="server-list">
          <div
            class="server-list-layer"
            v-for="item in productList"
            :key="item.id"
          >
            <div class="server-list-item">
              <div class="img-area">
                <img :src="item.iconPic" />
              </div>
              <div class="item-info">
                <div class="item-name">{{ item.name }}</div>
                <div class="item-price">¥{{ item.price }}元/起</div>
              </div>
            </div>
            <div class="left-txt">
              <p v-for="(i, index) in item.description" :key="index">{{ i }}</p>
            </div>
          </div>
        </div>
        <p class="serve-des">
          *上述官费为上月平均汇率预估价，实际以支付当日中国人民银行离岸汇率牌价为准
        </p>
        <p class="server-title">全球外观专利服务</p>
        <p class="sub-title">服务费(含官费)</p>
        <div :class="['server-title-div']">
          <div :class="['title-item', 'title-item-select']">
            外观专利申请服务
          </div>
        </div>
        <div class="server-list">
          <div
            class="server-list-layer"
            v-for="item in applyProductList"
            :key="item.id"
          >
            <div class="server-list-item">
              <div class="img-area">
                <img :src="item.iconPic" />
              </div>
              <div class="item-info">
                <div class="item-name">{{ item.name }}</div>
                <div class="item-price">¥{{ item.price }}元/起</div>
              </div>
            </div>
            <div class="left-txt">
              <p v-for="(i, index) in item.description" :key="index">{{ i }}</p>
            </div>
          </div>
        </div>
        <template
          v-if="intellectualCategoryList && intellectualCategoryList.length"
        >
          <p class="server-title">海关知识产权备案</p>
          <div :class="['server-title-div']">
            <div :class="['title-item', 'title-item-select']">
              海关知识产权备案服务
            </div>
          </div>
          <div class="server-list">
            <div
              class="server-list-layer"
              v-for="item in intellectualCategoryList"
              :key="item.id"
            >
              <div class="server-list-item">
                <div class="img-area">
                  <img :src="item.iconPic" />
                </div>
                <div class="item-info">
                  <div class="item-name">{{ item.name }}</div>
                  <div class="item-price">¥{{ item.price }}元/起</div>
                </div>
              </div>
              <div class="left-txt">
                <p v-for="(i, index) in item.description" :key="index">
                  {{ i }}
                </p>
              </div>
            </div>
          </div>
        </template>
        <!-- <img style="width:100%" src="/static/img/index/index2.jpg?v=1" alt /> -->
      </div>
      <div class="liucheng-div">
        <img
          src="/static/img/index/liucheng1.png"
          alt=""
          v-show="selectStatus == 1"
        />
        <img
          src="/static/img/index/liucheng1.jpg"
          alt=""
          v-show="selectStatus == 2"
        />
        <img
          src="/static/img/index/liucheng3.jpg"
          alt=""
          v-show="selectStatus == 3"
        />
        <img
          src="/static/img/index/liucheng4.jpg"
          alt=""
          v-show="selectStatus == 4"
        />
        <div
          :class="[
            'title-div',
            selectStatus == 1 ? 'first-title-div' : 'other-title-div'
          ]"
        >
          <div
            :class="[
              'title-item',
              selectStatus == i.value ? 'title-item-select' : ''
            ]"
            v-for="(i, k) in titleList"
            :key="k"
            @click="titleChange(i.value)"
          >
            {{ i.text }}
          </div>
        </div>
      </div>
      <img style="width:100%" src="/static/img/index/index3.png?v=0" alt />
      <!-- <img style="width:100%" src="/static/img/index/index4.png" alt /> -->
      <Footer></Footer>
    </div>
    <div
      v-show="liderValidation"
      :style="{ height: windowHeight + 'px' }"
      class="maskStyle"
    >
      <slider
        :phoneValue="phoneValue"
        :clickBtnNum="1"
        :slider="slider"
        @sliderSuccess="sliderSuccess"
        ref="slider"
      >
      </slider>
    </div>
    <div v-if="scrollTop" @click="scrollToTop" class="to-top">
      <img src="/static/img/icon/toTop.png" alt />
    </div>
    <registeredTipsModal ref="tipsModal" />
    <RegisterBtn />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import slider from '@/components/slider'
import {
  registered,
  channelNo,
  getSysPosterConfigList,
  linkToProgram,
  adRecordBanner,
  iprServiceItems,
  iprList
} from '@/api/land.js'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { throttle, getCookie, debounce } from '@/util/util'
import registeredTipsModal from '@/components/registeredTipsModal'
import { mixinAddRegVisitLog } from '@/util/mixins'
import { mixinCheckResponseIsErr } from '@ost/static/lib/mixin'
import RegisterBtn from '@/components/RegisterBtn'
import moment from 'moment'
import activityConfiguration from './activityConfiguration'

// 登录方式
const LOGIN_TYPE = {
  WX: 'WX',
  PHONE: 'PHONE'
}

export default {
  components: {
    Header,
    slider,
    registeredTipsModal,
    Footer,
    RegisterBtn,
    activityConfiguration
  },
  mixins: [mixinCheckResponseIsErr, mixinAddRegVisitLog],
  data () {
    return {
      moment,
      titleList: [
        {
          text: '美国',
          value: '1'
        },
        {
          text: '欧盟',
          value: '4'
        },
        {
          text: '英国',
          value: '2'
        },
        {
          text: '日本',
          value: '3'
        }
      ],
      categoryList: [],
      productList: [],
      images: [],
      url: '/index',
      phoneValue: '',
      slider: '#duoge1',
      liderValidation: false,
      windowHeight: '',
      codeNumber: false,
      codeButton: '发送验证码',
      codeMsgValue: '',
      passWordValue: '',
      surePwd: '',
      time: 60,
      agree: false,
      checkChannelFlag: true,
      aliCode: {},
      scrollTop: false,
      toast1: null,
      phoneInfo: '',
      selectStatus: 1,
      feeSelect: 10000,
      loading: false,
      showLogin: false,
      applyProductList: [],
      intellectualCategoryList: []
    }
  },
  computed: {
    LOGIN_TYPE () {
      return LOGIN_TYPE
    },
    activeActList () {
      const { infoList } = this.officialAct[this.activeOfficialAct] || []
      return (infoList || []).sort((a, b) => {
        return a.sort - b.sort
      })
    },
    commodityInfo () {
      return this.officialAct[this.activeOfficialAct]
    }
  },
  created () {
    let phone = navigator.userAgent // 设备机型的相关信息
    this.phoneInfo = phone.substring(
      phone.indexOf('(') + 1,
      phone.indexOf(';')
    ) // 处理信息，输出phone
    this.getImgList()
    this.windowHeight = document.documentElement.clientHeight
    document.title = '麦德通'
    document.documentElement.scrollTop = 0

    let channelNo =
      this.$route.query.channelNo || this.$route.query.channelCode
    if (channelNo) {
      this.aliCode.channelCode = channelNo
      this.channel()
    }
    this.getCatageList()
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  destroyed () {},
  watch: {
    $route () {
      if (this.toast1) {
        this.toast1.clear()
        this.toast1 = ''
      }
    }
  },
  methods: {
    titleChange (value) {
      this.selectStatus = value
    },
    serverChange (category) {
      this.feeSelect = category.value
      this.productList = category.list
    },
    getCatageList () {
      const cfgPromise = iprServiceItems({ type: 0 })
      const iprListPromise = iprList()
      Promise.all([cfgPromise, iprListPromise])
        .then(result => {
          const cfgData = result[0]
          const iprListData = result[1]
          // 同一服务类型对应的列表
          const listMap = {}

          if (iprListData && iprListData.code === 0) {
            iprListData.rows.forEach(item => {
              if (item.description) {
                try {
                  item.description = JSON.parse(item.description)
                } catch (error) {
                  item.description = []
                }
              } else {
                item.description = []
              }

              // 分类放到对对应数组
              const serviceType = item.serviceType + ''
              if (!listMap[serviceType]) {
                listMap[serviceType] = []
              }
              listMap[serviceType].push(item)
            })
          }

          let categoryList = []

          if (cfgData && cfgData.code === 0) {
            categoryList =
              cfgData.data.serviceTypeList.map(item => ({
                label: item.serviceTypeName,
                value: item.serviceType,
                list: listMap[item.serviceType] || []
              })) || []
          }
          this.categoryList = categoryList.filter(item => item.value != '10013' && item.value != '10061')
          let applycategoryList = categoryList.filter(item => item.value == '10013')
          let intellectualCategoryList = categoryList.filter(item => item.value == '10061')
          this.productList = (categoryList[0] && categoryList[0].list) || []
          this.applyProductList = (applycategoryList[0] && applycategoryList[0].list) || []
          this.intellectualCategoryList = (intellectualCategoryList[0] && intellectualCategoryList[0].list) || []
        }
      ).catch((e) => [])
    },
    getImgList () {
      getSysPosterConfigList({ module: 2, status: 1, showPageNames: 'index' })
        .then(res => {
          if (res.code == 0) {
            if (res.data && res.data.length > 0) {
              res.data.sort(function (a, b) {
                return a.sort - b.sort
              })
              let list = []
              res.data.forEach(i => {
                list.push({
                  posterId: i.posterId,
                  incrViewCount: 1
                })
              })
              // adRecordBanner(list).then();
              this.images = res.data
            }
          } else {
            this.$toast({ message: '系统繁忙，请稍后重试' })
          }
        })
        .catch(() => {
          // this.$toast({ message: '系统繁忙，请稍后重试' })
        })
    },
    tolink (e) {
      if (e.showType == '1') {
        adRecordBanner([{ posterId: e.posterId, incrClickCount: 1 }]).then()
        let href = e.showWay
        if (href.indexOf('http') != -1 || href.indexOf('https') != -1) {
          window.open(e.showWay, '_blank')
        } else {
          // if (href.indexOf('?type=') != -1) {
          //   this.$router.push({name: href.split('?type=')[0],query:{type:href.split('?type=')[1]}})
          // } else {
          //   this.$router.push({name: href})
          // }
          if (
            this.phoneInfo.indexOf('Windows') != -1 ||
            this.phoneInfo.indexOf('Macintosh') != -1
          ) {
            this.$toast({ message: '请用手机端打开' })
          } else {
            linkToProgram({ path: href })
              .then(res => {
                if (res.code == 0) {
                  window.location.href = res.data
                } else {
                  this.$toast({ message: '系统繁忙，请稍后重试' })
                }
              })
              .catch(() => {
                this.$toast({ message: '系统繁忙，请稍后重试' })
              })
          }
        }
      }
    },
    scrollToTop () {
      setTimeout(() => {
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }, 300)
    },
    handleScroll: throttle(function () {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 500) {
        this.scrollTop = true
      } else {
        this.scrollTop = false
      }
      this.showLogin = scrollTop > 620
    }, 500),
    toBuy (item) {
      item = JSON.parse(JSON.stringify(item))
      let typeId = ''
      let searchTitleValue = ''
      if (item.country > 100) {
        searchTitleValue = 'OD'
        item.country = ''
        typeId = 1
      } else {
        searchTitleValue = 'VAT'
        typeId = 0
      }
      if (
        this.phoneInfo.indexOf('Windows') != -1 ||
        this.phoneInfo.indexOf('Macintosh') != -1
      ) {
        window.location.href = `https://user.ippmaster.com/buy?typeId=${typeId}&country=${item.country}`
      } else {
        linkToProgram({
          path: 'pages/buy/buy',
          searchTitleValue,
          countryValue: item.country
        })
          .then(res => {
            if (res.code == 0) {
              window.location.href = res.data
            } else {
              this.$toast({ message: '系统繁忙，请稍后重试' })
            }
          })
          .catch(() => {
            this.$toast({ message: '系统繁忙，请稍后重试' })
          })
      }
    },
    ...mapActions(['GetInfo']),
    showPopup () {
      this.show = true
    },
    /**
     * @description 去登陆
     */
    toLogin () {
      if (
        this.phoneInfo.indexOf('Windows') != -1 ||
        this.phoneInfo.indexOf('Macintosh') != -1
      ) {
        this.redirectLogin(
          `user/register?channelCode=${this.$route.query.channelNo}`,
          '_blank'
        )
      } else {
        linkToProgram({
          path: 'minePages/pages/Login/index',
          channelNo: this.$route.query.channelNo || '',
          pageType: 'index',
          fromType: 'H5',
          H5ClickType: 1
        })
          .then(res => {
            if (res.code == 0) {
              window.location.href = res.data
            } else {
              this.$toast({ message: '系统繁忙，请稍后重试' })
            }
          })
          .catch(() => {
            this.$toast({ message: '系统繁忙，请稍后重试' })
          })
      }
    },
    redirectLogin (url, type) {
      // 方法在这
      let href = window.location.href
      let urlHeader =
        href.indexOf('uat-m.ippmaster.com') != -1
          ? 'https://uat-user.ippmaster.com/'
          : href.indexOf('m.ippmaster.com') != -1
            ? 'https://user.ippmaster.com/'
            : `http://${window.location.hostname}:9001/`
      window.open(urlHeader + url, type)
    },
    /**
     * @description 检验channelNo
     */
    channel () {
      channelNo({ channelId: this.aliCode.channelCode })
        .then(res => {
          if (res.code == 0) {
            if (!(res.rows.length > 0)) {
              this.$toast({
                message: `该注册码(${this.aliCode.channelCode}获取到的渠道码)有误，请联系您的客服经理`
              })
              this.checkChannelFlag = false
              this.$emit('channelNo', 'false')
            } else {
              this.$emit('channelNo', 'true')
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    /**
     * @description 用户协议
     */
    agreeClick () {
      this.agree = !this.agree
    },
    /**
     *@description 获取验证码的点击事件
     */
    getVerificationCode () {
      // 手机号为空
      if (this.phoneValue === '') {
        this.$toast({ message: '请输入手机号' })
        return
      }
      // 手机号格式不对
      if (!/^[1][0-9]{10}$/.test(this.phoneValue)) {
        this.$toast({ message: '请输入正确的手机号' })
        return
      }
      this.liderValidation = true
      if (this.liderValidation) {
        this.$refs.slider.getScroll()
      }
    },
    /**
     *@description 滑块验证通过
     */
    sliderSuccess (e) {
      if (e !== 'error') {
        this.aliCode = e
        let land5 = new Date().getTime()
        localStorage.setItem('zhuce', land5)
        this.codeTime()
      }
      setTimeout(() => {
        this.liderValidation = false
      }, 500)
    },
    /**
     *@description 获取验证码的button显示
     */
    codeTime () {
      this.codeNumber = true
      let interval = setInterval(() => {
        this.codeButton = `${this.time}s`
        if (this.time-- <= 0) {
          this.codeNumber = false
          this.codeButton = '发送验证码'
          this.time = 60
          window.clearInterval(interval)
        }
      }, 1000)
    },
    //
    openMiniProgram () {
      if (
        this.phone.indexOf('Windows') !== -1 ||
        this.phone.indexOf('Macintosh') !== -1
      ) {
        window.location.href = 'https://user.ippmaster.com/buy'
        return false
      }
      linkToProgram({ path: 'pages/buy/buy' })
        .then(res => {
          if (res.code === 0) {
            this.userConfirm(res.data)
          } else {
            this.$toast({ message: '系统繁忙，请稍后重试' })
          }
        })
        .catch(() => {
          this.$toast({ message: '系统繁忙，请稍后重试' })
        })
    },
    /**
     * 立即注册的点击事件
     */
    registerNow: debounce(function () {
      // 校验手机号为空
      if (this.phoneValue === '') {
        this.$toast({ message: '请输入手机号' })
        return
      }
      // 校验 手机号格式
      if (!/^[1][0-9]{10}$/.test(this.phoneValue)) {
        this.$toast({ message: '请输入正确的手机号' })
        return
      }
      // 校验验证码为空
      if (this.codeMsgValue === '') {
        this.$toast({ message: '请输入验证码' })
        return
      }
      // 校验密码为空
      if (this.passWordValue === '') {
        this.$toast({ message: '请输入密码' })
        return
      }
      // 校验密码格式错误
      if (
        !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,18}$/.test(this.passWordValue)
      ) {
        this.$toast({ message: '密码至少有一位数字和字母,6-18位字母数字组合' })
        return
      }
      if (this.surePwd === '') {
        this.$toast({
          message: '请输入确认密码'
        })
        return
      }
      if (this.surePwd !== this.passWordValue) {
        return this.$toast({ message: '两次输入的密码不一致，请检查后注册' })
      }
      // 校验协议
      if (!this.agree) {
        this.$toast({
          message: '请阅读并同意《麦德通用户服务协议》和《隐私及信息保护政策》'
        })
        return
      }
      if (!this.checkChannelFlag) {
        this.$toast({
          message: `该注册码(${this.aliCode.channelCode}获取到的渠道码)有误，请联系您的客服经理`
        })
        return
      }
      this.aliCode.smscode = this.codeMsgValue
      this.aliCode.password = window.btoa(this.passWordValue)
      this.aliCode.phonenumber = this.phoneValue
      if (this.$route.query.channelNo) {
        this.aliCode.channelCode = this.$route.query.channelNo
      } else {
        this.aliCode.channelCode = getCookie('channelCode')
      }
      let headers = {
        processData: 'false',
        contentType: 'false'
      }
      this.loading = true
      this.aliCode.fromType = this.$route.query.fromType == 'mp' ? 'OA' : 'H5'
      registered(this.aliCode, headers)
        .then(res => {
          this.loading = false
          let h = window.location.href
          let d = '.ippmaster.com'
          let href = 'https://user.ippmaster.com'
          if (h.indexOf('uat') != -1) {
            href = 'https://uat-user.ippmaster.com'
          } else if (h.indexOf('ost.com') != -1) {
            href = 'http://mc1.ost.com'
            d = '.ost.com'
          }
          if (res.code == 500) {
            if (res.msg == '账号已存在') {
              this.$refs.tipsModal.show('账号已存在')
            } else {
              this.$toast({ message: res.msg })
            }
          } else if (res.code == 0) {
            this.$refs.tipsModal.show()
          }
        })
        .catch(error => {
          this.loading = false
          this.$toast({ message: '系统错误，请稍后重试' })
          setTimeout(() => {
            this.toast1.clear()
            this.toast1 = ''
          }, 3000)
        })
        .finally(() => {
          this.toast1.clear()
          this.toast1 = ''
        })
    }, 500)
  }
}
</script>

<style lang="less" scoped>
#goTop {
  position: relative;
  box-sizing: border-box;
  padding-bottom: 143px;
}

.main {
  box-sizing: border-box;
  height: 100vh;
  padding-bottom: 143px;
  overflow: auto;
}

p {
  margin: 0;
}

.liucheng-div {
  position: relative;
}

.server-title-div {
  margin: 0.3rem auto 0.5rem;
  display: flex;
  justify-content: space-around;
  width: 80%;
}

.server-list {
  padding: 0 0.36rem;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.server-list-layer {
  width: 3.3rem;
  padding: 0.22rem 0;
  border: 1px solid #d1d1d1;
  margin-bottom: 0.27rem;
}

.server-list-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}

.img-area {
  left: 0.44rem;
  top: 0.22rem;
  width: 40%;
}

.img-area img {
  width: 0.8rem !important;
  height: 0.8rem;
  border-radius: 50%;
  object-fit: cover;
}

.item-info {
  width: 60%;
  text-align: left;
  overflow: hidden;
}

.item-name {
  overflow: hidden;
  color: #474747;
  font-size: 0.22rem;
  transform: scale(0.96);
}

.item-price {
  padding-left: 0.05rem;
  font-weight: 500;
  color: #d50031;
  font-size: 0.24rem;
}

.left-txt {
  width: 100%;
  font-size: 0.24rem;
  color: #474747;
  text-align: center;
}

.left-txt p {
  width: 130%;
  margin: 0 0 0 -15%;
  transform: scale(0.7);
}

.serve-des {
  width: 120%;
  margin-left: -10%;
  color: #474747;
  font-size: 0.24rem;
  transform: scale(0.8);
  margin-bottom: 0.5rem;
}

.title-div {
  position: absolute;
  left: 34%;
  display: flex;
  justify-content: space-between;
  width: 30%;
  justify-content: space-between;
}

.first-title-div {
  top: 12%;
}

.other-title-div {
  top: 23%;
}

.title-item {
  font-size: 0.2rem;
}

.title-item-select {
  color: #1363f7;
  border-bottom: 2px solid #1363f7;
}

.btn-bottom-text {
  font-size: 0.24rem;
  font-weight: 400;
  color: #606060;
  margin: 0.27rem 0 0.74rem 0;
}

.bg-white {
  width: 100%;
  background: white;
}

.bg-white-padding {
  padding: 0.32rem;
}

.list-img {
  float: left;
  width: 25%;
  height: 211px;
}

.list-img2 {
  height: 230px;
}

.to-top {
  position: fixed;
  width: 1rem !important;
  right: 5px;
  // top: 80% !important;
  bottom: 143px;
  height: 1rem !important;
  display: inline-block;
  border-radius: 100%;
  background: white;
  box-shadow: 10px 10px 70px gray;
}

.fix-login {
  position: fixed;
  bottom: 0.5rem;
  width: 100%;
  padding: 0 5%;
}

.to-top img {
  width: 100%;
}

.maskStyle {
  background: rgba(0, 0, 0, 0.6);
  z-index: 8;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}

.maskStyle p {
  text-align: left;
  height: 35px;
  line-height: 35px;
  margin: 8px 0;
  color: red;
  padding-left: 15px;
}

.banner {
  display: inline-block;
  width: 100%;
  height: 100%;
}

.top-title {
  margin: 0.5rem auto -0.01rem;
  text-align: center;
  color: #3f3f3f;
  font-size: 0.36rem;
}

.sub-title {
  text-align: center;
  color: #474747;
  font-size: 0.2rem;
}

.server-title {
  text-align: center;
  color: #3f3f3f;
  font-size: 0.36rem;
  margin: 0.5rem auto 0;
}

.index {
  width: 100%;
}

.index img {
  width: 100%;
}

input {
  border: none;
  outline: none;
  width: 100%;
  background: none;
}

.content {
  box-shadow: 0px 0px 40px 0px rgba(102, 102, 102, 0.07);
  border-radius: 10px;
  padding: 0.5rem 5%;
  margin: auto;
  background: #f8f8f9;
}

.title {
  border-radius: 10px;
  width: 6rem;
  margin: 0 auto 0.5rem;
  font-size: 0.36rem;
  font-weight: bold;
  color: #1363f7;
}

.btnClick {
  height: 0.84rem;
  background: #1363f7;
  border-radius: 45px;
  font-size: 0.36rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 0.84rem;
  margin-top: 0.4rem;
}

.disable {
  background: #c3c3c3;
  pointer-events: none;
}

img {
  display: inline-block;
}

.send-code {
  height: 0.55rem;
  background: #1363f7;
  border-radius: 0.1rem;
  line-height: 0.55rem;
  padding: 0 0.1rem;
  font-size: 0.22rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(254, 255, 255, 1);
}

.ipt-div {
  display: flex;
  height: 0.7rem;
  margin: 0.25rem 0;
}

.ipt-div div {
  border-bottom: 1px solid lightgray;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: 0.2rem;
}

.icon-span {
  position: relative;
  display: inline-block;
  width: 0.5rem;
  height: 100%;
}

.password-span {
  width: 0.4rem;
  margin: 0 0.05rem;
}

.icon-span img {
  position: absolute;
  width: 100%;
  bottom: 0.1rem;
  left: 0;
}

.agree {
  position: relative;
  display: flex;
  font-size: 0.2rem;
  padding-left: 0.3rem;
}

.radius1 {
  /* position: absolute;
  bottom: 0.08rem; */
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 100%;
  border: 1px solid #1363f7;
}

.radius2 {
  /* position: absolute;
  bottom: 0.08rem; */
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 100%;
  background: #1363f7;
}

.check {
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  position: absolute;
  top: 50%;
  margin-top: -0.125rem;
  left: 0rem;
}

.login-wrap {
  position: fixed;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  height: 143px;
  padding: 12px 15px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.wx-login-btn {
  height: 35px;
  border-radius: 18px;
  margin-bottom: 12px;
  background: #1363f7;
  text-align: center;
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 35px;
  color: #ffffff;
  cursor: pointer;
  user-select: none;
}

.phone-login-btn {
  box-sizing: border-box;
  height: 35px;
  border: 1px solid #1363f7;
  border-radius: 18px;
  margin-bottom: 11px;
  background: #ffffff;
  text-align: center;
  font-family: PingFang SC;
  font-size: 15px;
  line-height: 35px;
  color: #1363f7;
  cursor: pointer;
  user-select: none;
}

.activity {
  &-tab {
    --van-border-width-base: 0;
    --van-padding-md: 0;
    --van-tabs-card-height: 1.2rem;
    --van-tabs-default-color: #69727a;

    ::v-deep .van-tab--card.van-tab--active {
      background: #4fa9fd;
    }
  }

  &-main {
    display: flex;
    white-space: nowrap;
    overflow-x: auto;
    padding: 16px 0 16px 16px;
  }

  &-item {
    background: #fff;
    margin-right: 16px;
    min-width: 260px;
    padding: 26px 16px 66px;
    line-height: 20px;
    border-radius: 5px;
    position: relative;
    min-height: 246px;
    overflow: hidden;

    &-commodity {
      background-image: linear-gradient(to right, #e77b73, #ca453f);
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      font-weight: 600;
      color: #fff;
      min-width: 80px;
      text-align: center;
      line-height: 25px;
      height: 25px;
      padding: 0 10px 0 20px;
      border-bottom-left-radius: 50px;
    }

    &-title {
      display: flex;
      font-size: 16px;
      font-weight: 500;
      color: #242933;
      align-items: center;
    }

    &-country {
      width: 22px;
      height: 22px;
      margin-right: 10px;

      img {
        width: 100%;
      }
    }

    &-price {
      display: flex;
      align-items: center;
      padding: 8px 0;
    }

    &-new {
      font-size: 16px;
      font-weight: 600;
      color: #ca453f;

      & > * {
        font-size: 12px;
      }
    }

    &-old {
      font-size: 12px;
      font-weight: 400;
      color: #a7a9ad;
      text-decoration: line-through;
      margin-left: 10px;
    }

    &-label {
      border-radius: 3px;
      border: 1px solid #ca453f; // ignored
      display: inline-block;
      padding: 0 6px;
      font-size: 12px;
      color: #ca453f;
    }

    &-bought {
      display: flex;
      font-size: 10px;
      font-weight: 500;
      color: #69727a;
      line-height: 14px;
      align-items: center;
      padding: 14px 0;
    }

    &-progress {
      margin-right: 10px;
      height: 6px;
      background: #d8ecff;
      border-radius: 3px;
      flex: 1;
      position: relative;
      overflow: hidden;

      & > div {
        position: absolute;
        background: #4fa9fd;
        left: 0;
        border-radius: 3px;
        height: 100%;
        width: 0;
      }
    }

    &-count {
      font-size: 14px;
      font-weight: 400;
      color: #242933;
      display: flex;
      align-items: center;
      line-height: 18px;
    }

    &-buy {
      height: 34px;
      background: #4fa9fd;
      border-radius: 50px;
      position: absolute;
      left: 16px;
      right: 16px;
      bottom: 16px;
    }
  }
}

//优惠券
.discount-item {
  &-box {
    border-bottom: 1px dashed #e7e7e7;
    padding-bottom: 10px;
    line-height: 0;
  }

  &-title {
    font-size: 16px;
    font-weight: 500;
    color: #ca453f;
    line-height: 22px;
  }

  &-unit {
    font-size: 12px;
  }

  &-num {
    font-size: 22px;
    font-weight: 600;
    color: #ca453f;
    margin-right: 10px;
  }

  &-desc {
    font-size: 12px;
    font-weight: 400;
    color: #ca453f;
    height: 18px;
    line-height: 18px;
    border-radius: 3px;
    border: 1px solid #ca453f;
    display: inline-block;
    padding: 0 4px;
    margin-top: 8px;
  }

  &-rule {
    font-size: 11px;
    margin-top: 10px;
    background: linear-gradient(270deg, #fff8f3 0%, #fee8ed 100%);
    border-radius: 5px;
    padding: 8px 10px;
    font-weight: 400;
    color: #ca453f;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/registered.vue